/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from 'util/actions';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';

const SHOW_TOOLTIP = Symbol('ui/SHOW_TOOLTIP');
const CLOSE_TOOLTIP = Symbol('ui/CLOSE_TOOLTIP');

export type TooltipName = symbol | string;

type ShowTooltipAction = Action<typeof SHOW_TOOLTIP, TooltipName>;
type CloseTooltipAction = Action<typeof CLOSE_TOOLTIP, void>;

export const showTooltip = actionCreator<ShowTooltipAction>(SHOW_TOOLTIP);
export const closeTooltip = actionCreator<CloseTooltipAction>(CLOSE_TOOLTIP);

export type TooltipsState = string | null;

const initialState: TooltipsState = null;

export default createReducer(initialState, {
  [SHOW_TOOLTIP](state, { payload: name }: ShowTooltipAction) {
    return name;
  },

  [CLOSE_TOOLTIP](state, { payload: name }: CloseTooltipAction) {
    return null;
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/tooltips.ts